import { FC } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
import { Button } from '@/shared/uikitV2/Button';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { VfoChatEmptyModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../../interwill/containers/ModalContainerV2';

export const VfoChatEmptyModal: FC<VfoChatEmptyModalProps> = () => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'vfoChatEmpty' });
  const modals = useModalsStore();

  return (
    <ModalContainerV2 title={t('title')} pinBottom>
      <Container>
        <div>
          <div>{t('text1')}</div>
          <div>{t('text2')}</div>
        </div>
        <ButtonWrapper>
          <Icon name="users-three" size="s44" />
          <Button
            size="middle"
            type="default"
            onClick={() => {
              modals.closeModal();
              modals.openModal({
                type: 'AddOrEditCaseModal',
              });
            }}
          >
            {t('createCase')}
          </Button>
        </ButtonWrapper>
        <ButtonWrapper>
          <Icon name="user-circle" size="s44" />
          <Button
            size="middle"
            type="default"
            onClick={() => {
              modals.closeModal();
              modals.openModal({
                type: 'InviteMemberModal',
              });
            }}
          >
            {t('addMember')}
          </Button>
        </ButtonWrapper>
      </Container>
    </ModalContainerV2>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-size: 14px;
  line-height: 20px;
  padding-top: 24px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  color: ${COLORS.systemDark100};
  > * {
    width: 100%;
  }
`;
